import { render } from "./NaturalPersonForm.vue?vue&type=template&id=1bd1ef77"
import script from "./NaturalPersonForm.vue?vue&type=script&lang=js"
export * from "./NaturalPersonForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__